<template>
    <div :class="$style.AnalyzeSkuTable">
        <VScrollBox :class="$style.scrollbox"
                    theme="default"
                    resizable
        >
            <div :class="$style.table">
                <div :class="$style.thead">
                    <div :class="$style.tr">
                        <div :class="$style.th">
                            Название отчета
                        </div>
                        <div :class="$style.th">
                            Критерий анализа
                        </div>
                        <div :class="$style.th">
                            Количество товаров
                        </div>
                        <div :class="$style.th">
                            Дата проведения
                            анализа
                        </div>
                        <div :class="$style.th">
                            Статус
                        </div>
                    </div>
                </div>
                <div :class="$style.tbody">
                    <div v-for="n in 20"
                         :key="n"
                         :class="$style.tr"
                    >
                        <div :class="$style.td">
                            <div :class="$style.tdValue">
                                <NuxtLink :to="`/analyze-sku/report/${n}`">
                                    Подушка на кресло
                                </NuxtLink>
                            </div>
                        </div>
                        <div :class="$style.td">
                            <div :class="$style.tdValue">
                                Товар
                            </div>
                        </div>
                        <div :class="$style.td">
                            <div :class="$style.tdValue">
                                50
                            </div>
                        </div>
                        <div :class="$style.td">
                            <div :class="$style.tdValue">
                                15.09.2023
                            </div>
                        </div>
                        <div :class="[
                            $style.td,
                            $style.status,
                            { [$style._success]: n % 5 !== 0 },
                            { [$style._rejected]: n % 5 === 0 }]"
                        >
                            <div :class="$style.tdValue">
                                {{ n % 5 !== 0 ? 'Выполнен' : 'Ошибка' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </VScrollBox>
    </div>
</template>

<script setup>

</script>

<style
    lang="scss"
    module
>
    .AnalyzeSkuTable {
        border-radius: .8rem;
        background-color: var(--blue-100);
    }

    .table {
        width: 100%;
        padding: 2rem;
    }

    .scrollbox {
        max-height: 60rem;

        @include respond-to(mobile) {
            max-height: 44rem;
        }
    }

    .thead {
        position: sticky;
        top: 0;

        .th {
            background-color: var(--blue-100);
        }
    }

    .tr {
        display: flex;

        .td,
        .th {
            &:first-child {
                justify-content: flex-start;
                width: 44rem;

                @include respond-to(mobile) {
                    width: 36rem;
                }
            }

            &:last-child {
                flex-grow: 1;
                min-width: 30rem;

                @include respond-to(tablet) {
                    width: 44rem;
                }

                @include respond-to(mobile) {
                    width: 36rem;
                }
            }

            &:nth-child(2),
            &:nth-child(3),
            &:nth-child(4),
            &:nth-child(5) {
                width: 20rem;
            }
        }
    }

    .td,
    .th {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        text-align: center;
    }

    .td {
        flex-shrink: 0;
        font-size: 1.4rem;
        line-height: 1.2;

        &:first-child {
            .tdValue {
                justify-content: flex-start;
            }
        }

        &:not(:last-child) {
            border-right: 1px solid var(--grey-200);
        }
    }

    .th {
        padding: 1.2rem .8rem;
        border-bottom: 1px solid var(--grey-200);
        font-size: 1.4rem;
        font-weight: 700;
        line-height: 1.2;

        &:not(:last-child) {
            border-right: 1px solid var(--grey-200);
        }
    }

    .tbody {
        .tr {
            &:first-child {
                .td {
                    padding-top: 1.6rem;
                }
            }

            &:nth-child(odd) {
                .tdValue {
                    background-color: rgba(255 255 255 / 80%);
                }
            }
        }
    }

    .tdValue {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        padding: 1.2rem .8rem;
    }

    .status {
        &._success {
            color: var(--green-800);
        }

        &._rejected {
            color: var(--error-color);
        }

        .icon {
            width: 1.6rem;
            height: 1.6rem;
            margin-right: .6rem;
            color: currentcolor;
        }
    }
</style>
